import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import { MatLegacyAutocomplete as MatAutocomplete } from '@angular/material/legacy-autocomplete';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MatLegacyOption as MatOption } from '@angular/material/legacy-core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {TranslateService} from '@ngx-translate/core';
import {map, startWith} from 'rxjs/operators';
import {Contact} from '../../mail-flow/add-recipients/add-recipients.component';
import {Observable} from 'rxjs';
import {IdexService} from '../../../idex.service';
import { Toast } from 'app/shared/toast/toast';

declare var $: any;
@Component({
  selector: 'app-sender-reassign-dialog',
  templateUrl: './sender-reassign-dialog.component.html',
  styleUrls: ['./sender-reassign-dialog.component.css']
})
export class SenderReassignDialogComponent implements OnInit {
   @ViewChild('btnadd') btnAdd: MatButton;
   @ViewChild('matAutocompleteSignatoryEmail') matAutocompleteSignatoryEmail: MatAutocomplete;
   @ViewChild('matAutocompleteDeputyName') matAutocompleteDeputyName: MatAutocomplete;
   @ViewChild('matAutocompleteDeputyEmail') matAutocompleteDeputyEmail: MatAutocomplete;
   @ViewChild('contactOpt') contactOpt: MatOption;
   @ViewChild('contactEmailOpt') contactEmailOpt: MatOption;
   @ViewChild('toolbar') toolbar: ElementRef;
   public signatoryEmailInserted;
   public deputyNameInserted;
   public deputyEmailInserted;
   public groupInserted;
   public actionSelected;
   public checkEmail: boolean;
   public reassignTo: any;
   public reassignFrom: any;
   public reassignToName: any;
   errorMessage: string;
   contactsSignatory: Contact[] = [];
   contactsDeputy: Contact[] = [];
   filteredOptions: Observable<Contact[]>;
   signatoryEmailContrl = new FormControl();
   deputyNameContrl = new FormControl();
   deputyEmailContrl = new FormControl();
   currentLevelSignerData: any[] = [];
   currentLevelSignerDataAll: any[] = [];

   constructor(private dialogRef: MatDialogRef<SenderReassignDialogComponent>, private translate: TranslateService,
               public services: IdexService, @Inject(MAT_DIALOG_DATA) public data: any, private toast: Toast) {
   }

   ngOnInit() {
      this.clearControl();
      this.getCurrentLevelSignerData();
      this.getCurrentLevelSignerDataAll();
   }

   /**
    * function เครียร์ค่าต่างๆ
    * Paramenter : inputType : ข้อมูลที่รับจากแป้นพิมพ์
    */
   clearControl() {
      this.signatoryEmailInserted = '';
      this.deputyNameInserted = '';
      this.deputyEmailInserted = '';
      this.groupInserted = '';
      this.actionSelected = 'NS';
      this.contactsSignatory = [];
      this.contactsDeputy = [];
      this.filteredOptions = undefined;
   }

   selectKeyPressSignatoryEmail(event, cont: any) {
      if (event.key === 'Enter') {
         return;
      }
      this.filteredOptions = this.signatoryEmailContrl.valueChanges
         .pipe(
            startWith<string | Contact>(''),
            map(value => typeof value === 'string' ? value : value.email),
            map(email => email ? this.filter(email) : null)
         );
   }

   /**
    * function แปลงตัวอักษร
    * Paramenter : keyword : ข้อมูลที่รับจากแป้นพิมพ์
    */

   filter(keyword: string): Contact[] {
      const cont = this.contactsSignatory.filter(contact =>
         contact.name.toLowerCase().indexOf(keyword.toLowerCase()) === 0
         || contact.email.toLowerCase().indexOf(keyword.toLowerCase()) === 0);

      return cont;
   }

   highlightFirstOptionSignatoryEmail(event, input): void {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
         return;
      }
      this.contactsSignatory = [];
      const kw = input.trim();
      this.contactsSignatory = this.getSearchSignatory(kw);
      this.matAutocompleteSignatoryEmail._keyManager.setFirstItemActive();
   }

   selectSignatory(evt: any, contactOpt: any, cont: any): void {
      if (evt.source) {
         this.reassignFrom = contactOpt.email;
         this.signatoryEmailInserted = contactOpt.email;
      }
   }

   selectContactDeputy(evt: any, contactOpt: any, cont: any): void {
      if (evt.source) {
         this.reassignTo = contactOpt.email;
         this.reassignToName = contactOpt.name;
         this.deputyEmailInserted = contactOpt.email;
         this.deputyNameInserted = contactOpt.name;
      }
   }

   selectKeyPressDeputyName(event, cont: any) {
      if (event.key === 'Enter') {
         return;
      }
      this.filteredOptions = this.deputyNameContrl.valueChanges
         .pipe(
            startWith<string | Contact>(''),
            map(value => typeof value === 'string' ? value : value.name),
            map(name => name ? this.filter(name) : null)
         );
   }

   selectKeyPressDeputyEmail(event, cont: any) {
      if (event.key === 'Enter') {
         return;
      }
      this.filteredOptions = this.deputyEmailContrl.valueChanges
         .pipe(
            startWith<string | Contact>(''),
            map(value => typeof value === 'string' ? value : value.email),
            map(email => email ? this.filter(email) : null)
         );
   }

   highlightFirstOptionDeputyName(event, input): void {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
         return;
      }
      this.contactsDeputy = [];
      const kw = input.trim();
      this.contactsDeputy = this.getSearchDeputy(kw);
      this.matAutocompleteDeputyName._keyManager.setFirstItemActive();
   }

   highlightFirstOptionDeputyEmail(event, input): void {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
         return;
      }
      this.contactsDeputy = [];
      const kw = input.trim();
      this.contactsDeputy = this.getSearchDeputy(kw);
      this.matAutocompleteDeputyEmail._keyManager.setFirstItemActive();
   }

   validateEmail(cont: any) {
      // This is intentional.
   }

   displaySignatoryEmailFn(contact?: Contact): string | undefined {
      let email: any;
      if (contact !== null && contact !== undefined && contact.email !== undefined) {
         email = contact ? contact.email : '';
      } else {
         email = contact ? contact : '';
      }
      return contact ? email : '';
   }

   displayDeputyEmailFn(contact?: Contact): string | undefined {
      let email: any;
      if (contact !== null && contact !== undefined && contact.email !== undefined) {
         email = contact ? contact.email : '';
      } else {
         email = contact ? contact : '';
      }
      return contact ? email : '';
   }

   displayDeputyNameFn(contact?: Contact): string | undefined {
      let name: any;
      if (contact !== null && contact !== undefined && contact.name !== undefined) {
         name = contact ? contact.name : '';
      } else {
         name = contact ? contact : '';
      }
      return contact ? name : '';
   }

   /**
    * On dialog Reassign click action submit Reassign then call checkReassign
    * Paramenter : nameReassignTo ชื่อของคนที่ทำ Action Reassign, reassignTo email ของคนที่ทำ Action Reassign
    */
   onClickReAssign(from: string, to: string) {
      this.checkReassign(from, to, this.deputyNameInserted, this.data.item.taskId, this.data.item);
   }

   /**
    * Call service check permission reassign
    * Paramenter : nameReassignTo ชื่อของคนที่ทำ Action Reassign, reassignTo email ของคนที่ทำ Action Reassign
    *              data ข้อมูลเริ่มต้นของ Task ที่ service ส่งมาในตอนแรก
    */
   checkReassign(reassignFrom: string, reassignTo: string, reassignToName: string, taskId: number, data) {
      if (!this.validateReassign()) {
         return;
      }
      const nameValue = reassignToName.trim();
      if (/[<|>\\\/:?*']/g.test(nameValue)) {
         this.translate.get('alert.create_folder_error').subscribe(s => {
            this.errorMessage = s;
            $('#hint').addClass('hint-block');
            $('#hint').remove('hint-none');
         });
         return;
      } else {
         this.data.service.senderReAssign(reassignTo, nameValue, reassignFrom, data).subscribe(data1 => {
            this.data.toast.success(data1);
            this.checkEmail = true;
            $('#hint').addClass('hint-none');
            $('#hint').remove('hint-block');
            this.dialogRef.close(true);
         });
      }
   }

   getCurrentLevelSignerData() {
      this.services.getContactCurrentLevelNS(this.data.item.taskId, this.data.item.currentLevel).subscribe(data => {
         for (const element of data) {
            this.currentLevelSignerData.push({
               id: element.contactId,
               name: element.fullName,
               email: element.email,
            });
         }
      }, error => {
         this.errorMessage = error;
      });
   }

   getCurrentLevelSignerDataAll() {
      this.services.getContactCurrentLevelAll(this.data.item.taskId, this.data.item.currentLevel).subscribe(data => {
         for (const element of data) {
            this.currentLevelSignerDataAll.push({
               id: element.contactId,
               name: element.fullName,
               email: element.email,
            });
         }
      }, error => {
         this.errorMessage = error;
      });
   }

   getSearchSignatory(kw: any) {
      let search = [];
      if (/[<|>\\\/:?*"^{}%\[\]]/g.test(kw)) {
         this.translate.get('alert.create_folder_errors_full').subscribe(s => {
            this.toast.error(s);
         });
      } else {
         search = this.currentLevelSignerData.filter(item => item.name.toLowerCase().includes(kw.toLowerCase()) || item.email.toLowerCase().includes(kw.toLowerCase()));
      }
      return search;
   }

   getSearchDeputy(kw: any) {
      let search = [];
      if (/[<|>\\\/:?*"^{}%\[\]]/g.test(kw)) {
         this.translate.get('alert.create_folder_errors_full').subscribe(s => {
            this.toast.error(s);
         });
      } else if (kw.length > 0) {
         this.services.getContactShare(kw)
            .subscribe(
               data => {
                  for (const element of data) {
                     search.push({
                        id: element.contactId,
                        name: element.fullName,
                        email: element.email,
                     });
                  }
               }, error => {
                  this.errorMessage = error;
               });
         } else {
            search = [];
         }
      return search;
   }

   validateReassign() {
      if (!this.currentLevelSignerData.find(item => item.email === this.signatoryEmailInserted)) {
         this.translate.get('taskMenu.hint_select_signatory').subscribe(s => {
            this.errorMessage = s;
         });
         $('#hint').addClass('hint-block');
         $('#hint').remove('hint-none');
         return false;
      }
      if (this.currentLevelSignerDataAll.find(item => item.email === this.deputyEmailInserted)) {
         this.translate.get('taskMenu.hint_reassign_same_level').subscribe(s => {
            this.errorMessage = s;
         });
         $('#hint').addClass('hint-block');
         $('#hint').remove('hint-none');
         return false;
      }
      if (this.deputyEmailInserted === this.data.item.sender) {
         this.translate.get('taskMenu.hint_ressign_to_sender').subscribe(s => {
            this.errorMessage = s;
         });
         $('#hint').addClass('hint-block');
         $('#hint').remove('hint-none');
         return false;
      }
      return true;
   }
}
